import { render, staticRenderFns } from "./BaseConfirmDialog.vue?vue&type=template&id=691cca8a&"
import script from "./BaseConfirmDialog.vue?vue&type=script&lang=ts&"
export * from "./BaseConfirmDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports